function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -61)"
}, React.createElement("path", {
  d: "M409.266,349.223H406v1.289h4.555V346h-1.289Z",
  transform: "translate(-388.555 -272.754)",
  fill: "#fff"
}), React.createElement("path", {
  d: "M0,350.512H4.555v-1.289H1.289V346H0Z",
  transform: "translate(0 -272.754)",
  fill: "#fff"
}), React.createElement("path", {
  d: "M4.555,61H0v4.512H1.289V62.289H4.555Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M406,62.289h3.266v3.223h1.289V61H406Z",
  transform: "translate(-388.555)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 11.602,
  transform: "translate(2.621 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 9.023,
  transform: "translate(5.199 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 9.023,
  transform: "translate(7.777 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 11.602,
  transform: "translate(10.355 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 9.023,
  transform: "translate(12.934 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 9.023,
  transform: "translate(15.512 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 11.602,
  transform: "translate(18.09 63.578)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 1.289,
  transform: "translate(5.199 73.891)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 1.289,
  transform: "translate(7.777 73.891)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 1.289,
  transform: "translate(12.934 73.891)",
  fill: "#fff"
}), React.createElement("rect", {
  width: 1.289,
  height: 1.289,
  transform: "translate(15.512 73.891)",
  fill: "#fff"
}));

var SvgBarcode = function SvgBarcode(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 16.758,
    viewBox: "0 0 22 16.758",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode.82af7bc9.svg";
export { ForwardRef as ReactComponent };